import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function GoogleCallbackHandler({ setCurrentUser }) {
  const navigate = useNavigate();

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 5; // Increased attempts
    const retryDelay = 500; // Increased delay

    const checkLogin = async () => {
      console.log("🔄 GoogleCallbackHandler: Initiating checkLogin attempt:", attempts + 1);
      try {
        const res = await fetch("/auth/me", { credentials: "include" });
        console.log("➡️ GoogleCallbackHandler: Response from /auth/me:", res);

        if (res.ok) {
          const data = await res.json();
          console.log("✅ GoogleCallbackHandler: /auth/me response data:", data);
          if (data.user) {
            console.log("👤 GoogleCallbackHandler: User found, navigating to /");
            setCurrentUser(data.user);
            navigate("/"); // or to /profile-setup if needed
            return;
          } else {
            console.log("⚠️ GoogleCallbackHandler: /auth/me returned ok, but no user found in data.");
          }
        } else {
          console.log("❌ GoogleCallbackHandler: /auth/me request failed with status:", res.status);
        }

        // Retry up to maxAttempts times
        if (attempts < maxAttempts) {
          attempts++;
          console.log(`⏳ GoogleCallbackHandler: Retrying in ${retryDelay}ms (attempt ${attempts + 1}/${maxAttempts})`);
          setTimeout(checkLogin, retryDelay);
        } else {
          console.log("🚪 GoogleCallbackHandler: Max retry attempts reached, navigating to /login");
          navigate("/login"); // fallback if still not logged in
        }
      } catch (error) {
        console.error("🚨 GoogleCallbackHandler: Error during /auth/me request:", error);
        console.log("🚪 GoogleCallbackHandler: Navigating to /login due to error");
        navigate("/login");
      }
    };

    checkLogin();
  }, [navigate, setCurrentUser]);

  return <div>Logging you in…</div>;
}

export default GoogleCallbackHandler;